<div class="stepper-container" [class.is-disabled]="disabled()">
  <button class="circle-btn" (click)="decrement()" [disabled]="disabled() || value() <= 0">
    <bo-icon icon="minus" [isNativeIcon]="true" />
  </button>

  <input
    class="value-display"
    type="number"
    min="0"
    inputmode="numeric"
    [value]="value()"
    [disabled]="disabled()"
    (input)="onInput($event)"
    (blur)="onBlur()"
    (keydown.enter)="onEnter($event)"
  />

  <button class="circle-btn" (click)="increment()" [disabled]="disabled()">
    <bo-icon icon="plus" [isNativeIcon]="true" />
  </button>

  <span class="label">{{ displayMessage() | translate }}</span>
</div>
